import useAuth from '@/hooks/useAuth';
import { SideBarRouteOption } from '@/types';
import { DashboardLayout } from 'moh-ui';
import { BsFillGearFill } from 'react-icons/bs';
import { RiLogoutCircleRLine } from 'react-icons/ri';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import '../../styles/App.css';
import DeleteInsuranceModal from '../modals/DeleteInsuranceModal';
import ViewApprovalRequest from '../modals/ViewApprovalRequest';
import AddOrEditTariff from '../modals/moh-admin/tariff/AddOrEditTariff';
import DeleteTariff from '../modals/moh-admin/tariff/DeleteTariff';
import AddOrEditRole from '../modals/AddOrEditRole';
import DeleteRoleModal from '../modals/DeleteRoleModal';
import CreateTokenModal from '../modals/CreateToken';
import ViewTokenModal from '../modals/ViewToken';
import RegenerateTokenModal from '../modals/RegenerateToken';
import UpdateTokenOriginModal from '../modals/UpdateTokenOrigin';
import DeactivateTokenModal from '../modals/DeactivateToken';
import ActivateTokenModal from '../modals/ActivateToken';

export default function MainLayout({ routes }: { routes: SideBarRouteOption[] }) {
   const { user, logout } = useAuth();
   const navigate = useNavigate();
   const location = useLocation();
   return (
      <>
         <ViewApprovalRequest />
         {/* <AddOrEditTariff /> */}
         {/* <DeleteTariff /> */}
         <DeleteInsuranceModal />
         {/* <AddOrEditRole /> */}
         {/* <DeleteRoleModal /> */}
         <CreateTokenModal />
         <ViewTokenModal />
         <RegenerateTokenModal />
         <UpdateTokenOriginModal />
         <DeactivateTokenModal />
         <ActivateTokenModal />

         <DashboardLayout
            layoutMode="horizontal"
            navigationProps={{
               routes: routes,
               isItemActive: (path) => {
                  return path === location.pathname;
               },
               LinkComponent: Link,
            }}
            topbarProps={{
               user: {
                  username: user?.username ?? '',
                  email: user?.email ?? '',
               },
               logoProps: {
                  subtitle: 'Insurance Services Repository',
                  onClick: () => navigate('/' + location.pathname.split('/')[1]),
               },
               notificationProps: {
                  notifications: [],
                  markAllAsRead: () => {},
                  markNotificationAsRead: () => {},
               },
               profileDropdownItems: [
                  {
                     label: 'Account Settings',
                     icon: <BsFillGearFill size={20} />,
                     onClick: () => navigate('/' + location.pathname.split('/')[1] + '/profile'),
                  },
                  {
                     label: 'Logout',
                     icon: <RiLogoutCircleRLine size={20} />,
                     onClick: () => logout(),
                  },
               ],
            }}
         >
            <Outlet />
         </DashboardLayout>
      </>
   );
}
